<nav class="bottom-nav flex align-items-center justify-content-around w-full" aria-label="Navegação principal">
  <!-- Slot 1: Início — sempre fixo à esquerda -->
  <a
    routerLink="/home"
    routerLinkActive="active"
    class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1 no-underline"
    pRipple
  >
    <i class="pi pi-home"></i>
    <span>Início</span>
  </a>

  <!-- Slot 2: no checkout (cliente logado) "Eventos" dá lugar a "Ingressos";
       fora dele, rola até a lista de eventos da home (a busca por nome já
       existe no header — repetir aqui seria redundante) -->
  @if (isCheckoutMode()) {
    <a
      routerLink="/perfil"
      [queryParams]="{ tab: 2 }"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1 no-underline"
      pRipple
    >
      <i class="pi pi-ticket"></i>
      <span>Ingressos</span>
    </a>
  } @else {
    <button
      type="button"
      (click)="goToEvents()"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1"
      pRipple
    >
      <i class="pi pi-calendar"></i>
      <span>Eventos</span>
    </button>
  }

  <!-- Slot 3: Continuar (checkout — a ação principal da compra fica
       sempre à mão no rodapé) / Cadastrar Evento (produtor — "Meus
       Eventos" já está acessível pelo menu lateral/header, e o slot 2
       já cobre a busca de eventos; aqui o mais útil no rodapé é o
       atalho pra criar um evento novo) / Comprar (detalhe do evento,
       comprador) / Ingressos (comprador logado) / Cadastre seu evento
       (deslogado — /ingressos exige login e falhava silenciosamente
       pra quem não estava logado) -->
  @if (isCheckoutMode()) {
    <button
      type="button"
      (click)="onCheckoutContinue()"
      [disabled]="checkoutCta()?.disabled() || checkoutCta()?.loading()"
      class="bottom-nav-item bottom-nav-item--highlight flex flex-column align-items-center justify-content-center gap-1"
      pRipple
    >
      @if (checkoutCta()?.loading()) {
        <i class="pi pi-spin pi-spinner"></i>
      } @else {
        <i class="pi pi-arrow-circle-right"></i>
      }
      <span>Continuar</span>
    </button>
  } @else if (isProducer()) {
    <button
      type="button"
      (click)="createEvent()"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1 no-underline"
      pRipple
    >
      <i class="pi pi-plus-circle"></i>
      <span>Criar Evento</span>
    </button>
  } @else if (isEventDetail()) {
    <button
      type="button"
      (click)="scrollToTickets()"
      class="bottom-nav-item bottom-nav-item--highlight flex flex-column align-items-center justify-content-center gap-1"
      pRipple
    >
      <i class="pi pi-ticket"></i>
      <span>Comprar</span>
    </button>
  } @else if (isLogged()) {
    <a
      routerLink="/perfil"
      [queryParams]="{ tab: 2 }"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1 no-underline"
      pRipple
    >
      <i class="pi pi-ticket"></i>
      <span>Ingressos</span>
    </a>
  } @else {
    <a
      routerLink="/auth/registro/criador-de-evento"
      routerLinkActive="active"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1 no-underline"
      pRipple
    >
      <i class="pi pi-megaphone"></i>
      <span>Criar Evento</span>
    </a>
  }

  <!-- Slot 4: Voltar (sub-páginas, ex: detalhe do evento) ou Conta -->
  @if (isSubPage()) {
    <button
      type="button"
      (click)="goBack()"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1"
      pRipple
    >
      <i class="pi pi-arrow-left"></i>
      <span>Voltar</span>
    </button>
  } @else if (isLogged()) {
    <a
      routerLink="/perfil"
      routerLinkActive="active"
      [routerLinkActiveOptions]="{ paths: 'exact', queryParams: 'exact', matrixParams: 'ignored', fragment: 'ignored' }"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1 no-underline"
      pRipple
    >
      <i class="pi pi-user"></i>
      <span>Conta</span>
    </a>
  } @else {
    <button
      type="button"
      (click)="onAccountClick()"
      class="bottom-nav-item flex flex-column align-items-center justify-content-center gap-1"
      pRipple
    >
      <i class="pi pi-user"></i>
      <span>Conta</span>
    </button>
  }
</nav>
